import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../services/api";
import styles from "./UserAccess.module.css";
import logoInteagro from "../../assets/img/logo-inteagro.png";

const AtivarConta = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");

  const [loading, setLoading] = useState(true);
  const [valid, setValid] = useState(false);
  const [nome, setNome] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [tipoMensagem, setTipoMensagem] = useState<"success" | "error" | "">("");

  useEffect(() => {
    const validarToken = async () => {
      try {
        const response = await api.post("/users/validate-invite-token", { token });
        setValid(!!response.data?.valid);
        setNome(response.data?.nome || "");
      } catch {
        setValid(false);
      } finally {
        setLoading(false);
      }
    };

    if (!token) {
      setLoading(false);
      setValid(false);
      return;
    }

    validarToken();
  }, [token]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMensagem("");
    setTipoMensagem("");

    if (!password || password.length < 8) {
      setMensagem("A senha deve ter pelo menos 8 caracteres.");
      setTipoMensagem("error");
      return;
    }

    if (password !== confirmPassword) {
      setMensagem("As senhas não conferem.");
      setTipoMensagem("error");
      return;
    }

    try {
      setSalvando(true);

      await api.post("/users/activate-account", {
        token,
        password,
      });

      setMensagem("Conta ativada com sucesso. Redirecionando para o login...");
      setTipoMensagem("success");

      setTimeout(() => {
        navigate("/");
      }, 1500);
    } catch (error: any) {
      setMensagem(error.response?.data?.message || "Erro ao ativar conta.");
      setTipoMensagem("error");
    } finally {
      setSalvando(false);
    }
  };

  if (loading) {
    return (
      <div className={styles.main}>
        <div className={styles.contentLeftSide}>
          <h1 className={styles.title}>
            <span className={styles.textGradientAnimated}>Inteagro</span> Conectando o campo ao futuro.
          </h1>
        </div>
        <div className={styles.containerForm}>
          <div className={styles.infoBox}>Validando link...</div>
        </div>
      </div>
    );
  }

  if (!valid) {
    return (
      <div className={styles.main}>
        <div className={styles.contentLeftSide}>
          <h1 className={styles.title}>
            <span className={styles.textGradientAnimated}>Inteagro</span> Conectando o campo ao futuro.
          </h1>
        </div>
        <div className={styles.containerForm}>
          <div className={styles.infoBox}>Link inválido ou expirado.</div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.main}>
      <div className={styles.contentLeftSide}>

        <div className={`${styles.contentLeftSide} desktop`}>
        <h1 className={styles.title}>
          <span className={styles.textGradientAnimated}>Inteagro</span> Conectando o campo ao futuro.
        </h1>
      </div>
      </div>

      <div className={styles.containerForm}>
        <div className={styles.card}>
          <div className={styles.logoWrap}>
            <img src={logoInteagro} alt="Inteagro" className={styles.logo} />
          </div>

          <h2 className={styles.heading}>Ativar conta</h2>
          <p className={styles.subtext}>
            Olá, <strong>{nome}</strong>. Defina sua senha para acessar o sistema.
          </p>

          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.field}>
              <label>Nova senha</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Digite sua senha"
              />
            </div>

            <div className={styles.field}>
              <label>Confirmar senha</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirme sua senha"
              />
            </div>

            <div className={styles.passwordHint}>
              Use pelo menos 8 caracteres.
            </div>

            <button type="submit" disabled={salvando} className={styles.submitBtn}>
              {salvando ? "Salvando..." : "Criar senha"}
            </button>
          </form>

          {!!mensagem && (
            <div
              className={`${styles.message} ${
                tipoMensagem === "success" ? styles.messageSuccess : styles.messageError
              }`}
            >
              {mensagem}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AtivarConta;